import { FetchPolicy, ApolloQueryResult } from 'apollo-client';
import { call, getContext } from 'redux-saga/effects';
import { SagaContext } from 'shared/types/common';
import { Services } from 'init/services';
import { stockPriceQuery } from 'queries/StockPrice';
import {
  StockPriceQuery,
  StockPriceQuery_stocksRemote_product_realtimeDataPeek as RealtimeDataPeek,
} from 'queries/StockPrice/__generated__/StockPriceQuery';

export function* getStockPrice(id: number, fetchPolicy: FetchPolicy = 'network-only') {
  const apolloClient: Services[SagaContext.ApolloClient] = yield getContext(
    SagaContext.ApolloClient
  );

  const { data }: ApolloQueryResult<StockPriceQuery> = yield call(
    apolloClient.query,
    stockPriceQuery({ id }, fetchPolicy)
  );

  const { product } = data.stocksRemote;

  if (!product || !product.realtimeDataPeek) {
    return {};
  }
  return product.realtimeDataPeek;
}

export type StockPrice = RealtimeDataPeek;
